<div class="itsl-course-info-box__image">
    {#if imageUrl}
        <img src={imageUrl} style={imageStyle} alt={imageDescription} />
    {:else}
        <div class="itsl-course-info-box__image-placeholder" style={imageStyle}></div>
    {/if}
</div>

<script>
    export let imageColour;
    export let imageDescription = "";
    export let imageUrl = "";

    const imageStyle = `background-color: ${imageColour}`;
</script>
